// @ts-nocheck
import { createAsyncAction } from '../../../core/store/actionCreators';
import { CLEAR_TRACERS } from './tracerActionTypes';
import TracerService from '../services/TracerService';

export const clearTracers = createAsyncAction(CLEAR_TRACERS, async (userId, traceServices) => {
  const { data } = await TracerService.clearTracers(userId, traceServices);
  return data;
});
